import { apiClient } from '../../client'
import endpoints from '../../endpoints'
import { unwrapSingle } from '../../normalize'
import type { FarmFilterOptions } from '../../../../types/apiModels'

export default async function getFarmFilterOptions({
  signal,
}: {
  signal?: AbortSignal
}): Promise<FarmFilterOptions> {
  const response = await apiClient.get(endpoints.v2.farms.filterOptions, { signal })
  return unwrapSingle<FarmFilterOptions>(response)
}
